import { Component, Input } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseComponent } from 'app/base';

@Component({
    selector: 'funcao-exercida-homologacao',
    templateUrl: './funcao-exercida-homologacao.component.html'
})
export class FuncaoExercidaHomologacaoComponent extends BaseComponent {

    funcaoExercida: SelectItem[] = [];
    listaFuncao: any[];
    todasHipoteses: any[];

    @Input() cpf: string;
    @Input() id_natureza: number;
    @Input() exercicio: number;

    ngOnInit() {
        this.service.ListarTodos('hipoteses').subscribe(data => this.todasHipoteses = data);
        this.service.ListarTodos('combo/funcaoExercida').subscribe(data => this.funcaoExercida = data.filter(x => x.data_exclusao == null));
        this.service.ListarFuncoesExercidas(this.cpf, this.id_natureza, this.exercicio).subscribe(data => this.listaFuncao = data);
    }
}


// WEBPACK FOOTER //
// ./src/app/Componentes/funcao-exercida-homologacao/funcao-exercida-homologacao.component.ts